export default {
  /*按钮*/
  bt:{
    search:"Tìm kiếm",
    query:"Tra cứu",
    operation:"Thao tác",
    add:"Thêm",
    edit:"Sửa",
    delete:"Xóa",
    down:"Tải",
    export:"Dẫn ra",
    upload:"Tải lên",
    proposal:"审批",
    confirm:"确定",
    close:"关闭",
  },
  /*公用字段或工具函数字段*/
  common:{
    startTime:"Thời gian bắt đầu",
    endTime:"Thời gian kết thúc",
    creator:"Người xây dựng",
    updater:"Người làm mới",
    createTime:"Thời gian xây dựng",
    updateTime:"Thời gian làm mới",
    phone:"Số điện thoại",
    name:"Họ tên",
    email:"Email",
    idNumber:"Số CMND",
    status:"Trạng thái",
    remark:"Ghi chú",
  },
  active:{
    activeNo: "Số hoạt động",
    activeName: "Tên hoạt động",
    activeTime: "thời gian hoạt động",
    openTime: "Thời gian mở tài khoản",
    status: "Trạng thái hoạt động",
    androidChannel: "kênh android",
    iosChannel: "kênh ios",
    review: "đánh giá",
    disable: "Tắt",
    enable: "Bật",
    bonusDesc: "Mô tả tiền thưởng",
    url: "Địa chỉ liên kết",
    activeDescribe: "Mô tả Hoạt động",
    userList: "Danh sách đen",
    joinCustomerStatus: "Trạng thái người dùng tham gia",
    alwaysShow: "Khách du lịch có đưa phong bì đỏ hay không",
    limitType: "Loại thời gian giới hạn",
    limitDays: "Ngày trong thời gian giới hạn",
    taskContent: "Nhiệm vụ và Phần thưởng",
    name: "Tên kênh",
    pkg: "tên gói kênh",
    os: "Loại Hệ thống",
    pleaseInput: "Vui lòng điền vào",
    valid: "Xác minh dữ liệu",
    enter: "OK",
    startTimeError: "Thời gian bắt đầu hoạt động không được nhỏ hơn thời gian hiện tại",
    taskContentComplete: "Thời gian bắt đầu hoạt động không được nhỏ hơn thời gian hiện tại",
    taskContentRepeat: "Không đặt nhiệm vụ lặp lại",
    customerNo: "Tài khoản",
    task: "Task",
    startTime: "Thời gian bắt đầu hoạt động",
    endTime: "Thời gian kết thúc hoạt động",
    customerCreateStartTime: "Thời gian bắt đầu mở tài khoản",
    customerCreateEndTime: "Thời gian kết thúc mở tài khoản",
    customerActiisedStartTime: "Thời gian bắt đầu được kích hoạt",
    customerActiisedEndTime: "Thời gian kết thúc được kích hoạt",
    chineseName: "Tên khách hàng",
    task1: "Mở tài khoản thực",
    task3: "Hoàn thành thông tin",
    task4: "Khoản tiền gửi đầu tiên",
    task5: "Tích lũy giao dịch 1 lô ngoại hối",
    task6: "Giao dịch tích lũy của 1 lô hàng hóa",
    task7: "Chỉ số giao dịch tích lũy 1 lô",
    task8: "Giao dịch tích lũy của 1 nắm tiền kỹ thuật số",
    task9: "Lệnh giao dịch",
    task10: "Giao dịch tích lũy 1 lô cổ phiếu",
    customerCreateTime: "Thời gian mở tài khoản người dùng",
    customerActiisedTime: "Thời gian kích hoạt người dùng",
    customerStatus: "Trạng thái người dùng",
    amount: "Số tiền thưởng",
    moneyCny: "Số tiền thưởng (RMB)",
    selectTask: "Vui lòng chọn một công việc",
    taskTitle: "Tiêu đề nhiệm vụ",
    taskDescribe: "Mô tả nhiệm vụ",
    rewardValue: "Số tiền thưởng ($)",
    orderNo: "Dòng phát hành",
    taskName: "Tên công việc",
    platform: "platform",
  },
  pushMsg:{
    parent:"Thuộc sở hữu của doanh nghiệp",
    appName:"Ứng dụng tên",
    status:"Trạng thái",
    remark:"Từng dùng",
    appKey:"Chìa khóa để áp dụng",
    appSecret:"Ứng dụng Secret",
    createTime:"Tạo thời gian",
    updateTime:"Cập nhật thời gian",
    updater:"Người cập nhật",
    env:"Đẩy môi trường",
    prd:"Môi trường sản xuất",
    dev:"Môi trường phát triển",
    check:"Chuyển đổi môi trường",
    isStop:"Xác định đình chỉ?",
    isEnable:"Xác định kích hoạt?",
    fabu:"+Thông báo thông báo",
    releaseStatus:"Đồng bộ hóa",
    msgTitle:"Tiêu đề tin nhắn",
    business:"Thuộc sở hữu của doanh nghiệp",
    platform:"Đẩy nền tảng",
    msgLanguage:"Ngôn ngữ",
    pushTime:"Đẩy thời gian",
    pushConfig:"Đẩy cấu hình",
    type:"Kiểu thông điệp",
    pushStatus:"Đẩy trạng thái",
    msgPlatform:"Ứng dụng nền tảng",
    channel:"kênh",
    targetUsers:"Người dùng đích",
    users:"Người dùng đích 1",
    businessId:"Thuộc sở hữu của doanh nghiệp",
    updateDate:"Sửa đổi thời gian",
    push:"Đồng bộ hóa",
    pushMode:"đẩy",
    msgRemark:"Mô tả tin nhắn",
    msgContent:"Nội dung tin nhắn",
    fabudao:"Phát hành đến",
    fabuson:"Người xuất bản",
    yewu:"Kinh doanh",
    createDate:"Thời gian phát hành",
    createBy:"Người sáng lập",
  },
  quantityTask:{
    ctime:"創建時間",
    customerNumber:"賬號",
    activeTime:"激活時間",
    userName:"用戶名",
    phone:"手機號",
    taskType:"任務類型",
    taskName:"任務名",
    quantity:"金幣值",
    businessType:"業務類型",
    companyId:"公司ID",
    detail:"詳情",
    status:"狀態",
    startTime:"開始時間",
    endTime:"結束時間",
    businessTypeAlias:"業務組別名",
    utime:"更新時間",
    uname:"操作人",
    taskStep:"活動階段",
    taskId:"活動ID",
    name:"名稱",
    rule:"活動規則",
    illustrate:"說明",
    title:"標題",
    category:"活動種類",
    addtionalConfig:"额外奖励设置",
    awardStatus:"領取狀態",
    finishedStatus:"完成狀態",
    typeName:"活動類型",
    type:"類型",
    proposalId:"提案號",
    taskStatus:"啟/禁",
    balance:"餘額",
    setting:"设置",
    exrate:"兌換比例",
    maxEx:"免審批額度（每天）",
    gmt:"GTM時區",
    examount:"兌換總額",
    proposalType:"提案類型",
    acceptTime:"領取時間",
    gtsManagerFac:"兌換通道",
    dicesDetailList:'明细记录详情',
  }

};
